module.exports = __webpack_public_path__ + "static/img/fk.519e3de5.svg";